import { z } from 'zod';
import { emailSchema, postcodeSchema } from './common.js';
export const LEAD_STATUSES = ['new', 'qualified', 'quoted', 'won', 'lost'];
/** Public quote form — posted by unauthenticated website visitors. */
export const leadSubmitSchema = z.object({
    contactName: z.string().trim().min(2).max(120),
    contactEmail: emailSchema,
    contactPhone: z.string().trim().min(7).max(40).optional(),
    company: z.string().trim().max(160).optional(),
    pickupPostcode: postcodeSchema.optional(),
    dropoffPostcode: postcodeSchema.optional(),
    /** Free-text timing from the visitor: "ASAP", "tomorrow AM", or an ISO datetime. */
    requestedFor: z.string().trim().max(120).optional(),
    message: z.string().trim().max(2000).optional(),
    /** Honeypot — invisible to humans; bots that fill it get a fake 201 and no row. */
    website: z.string().max(200).optional(),
});
/** Admin workflow update: push a lead along the pipeline / attach internal notes. */
export const leadUpdateSchema = z
    .object({
    status: z.enum(LEAD_STATUSES).optional(),
    adminNotes: z.string().trim().max(2000).optional(),
})
    .refine((v) => v.status !== undefined || v.adminNotes !== undefined, {
    message: 'Provide status or adminNotes',
});
export const leadListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
    status: z.enum(LEAD_STATUSES).optional(),
    search: z.string().trim().max(120).optional(),
});
//# sourceMappingURL=lead.js.map